import { BreadcrumbList } from '@/components/Breadcrumbs/BreadcrumbList';
import { BreadcrumbItem } from '@/components/Breadcrumbs/BreadcrumbItem';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { EquipmentInfosManagement } from '../components/EquipmentInfosManagement';
import { useNavigate } from 'react-router-dom';
import {
  TEquipmentSchema,
  equipmentSchema,
} from '@/schemas/equipment/equipment.schema';
import { useCreateEquipment } from '@/hooks/equipment.hooks';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '@/utils/language.utils';

export const CreateEquipmentPage = () => {
  const { t } = useTranslation('equipment');
  const navigate = useNavigate();

  const {
    watch: watchEquipment,
    control: equipmentControl,
    register: registerEquipment,
    setValue: setEquipmentValue,
    setError: setEquipmentError,
    handleSubmit: handleSubmitEquipment,
    formState: { errors: equipmentErrors, isSubmitting: isSubmittingEquipment },
  } = useForm<TEquipmentSchema>({
    resolver: zodResolver(equipmentSchema),
  });

  const { mutate: mutateCreateEquipment, isPending: isPendingCreateEquipment } =
    useCreateEquipment({
      t,
      handleSuccess: () => navigate('/equipments'),
    });

  const onSubmitEquipment = (equipment: TEquipmentSchema) => {
    const { languageCode } = getLanguage();

    const dataWithLanguageCode = {
      ...equipment,
      languageCode,
    };

    mutateCreateEquipment(dataWithLanguageCode);
  };

  return (
    <>
      <PageHeader
        backToLink="/equipments"
        title={t('common:equipment')}
        headingElement={
          <BreadcrumbList>
            <BreadcrumbItem text={t('equipmentList')} linkTo="/equipments" />
            <BreadcrumbItem text={t('common:equipment')} active />
          </BreadcrumbList>
        }
      />
      <div className="flex flex-col gap-12">
        <EquipmentInfosManagement<TEquipmentSchema>
          t={t}
          watch={watchEquipment}
          control={equipmentControl}
          register={registerEquipment}
          setValue={setEquipmentValue}
          setError={setEquipmentError}
          errors={equipmentErrors}
          submitDisabled={isSubmittingEquipment || isPendingCreateEquipment}
          onSubmit={handleSubmitEquipment(onSubmitEquipment)}
        />
      </div>
    </>
  );
};
